export const getAddon = (addonsAvailable, addonKey) =>
    addonsAvailable?.find(ele => ele.addon_key === addonKey);

export const getAddonId = (addonsAvailable, addonKey) => {
    const addon = getAddon(addonsAvailable, addonKey);
    return addon?.plan_addon_id;
}
